import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";



@Injectable({
    providedIn: 'root'
})
export class LoginApiServices {

    constructor(private httpClient: HttpClient) {

    }

    Loging(codinter: string, password: string) {
    let postdata={codinter:codinter,password:password};
        return this.httpClient.post(environment.baseUrl + "/login/login.php", postdata);
    }

    password(postdata){
        return this.httpClient.post(environment.baseUrl + "/login/password.php", postdata);
    }

    passwordC(postdata){
        return this.httpClient.post(environment.baseUrl + "/login/passwordC.php", postdata);
    }

    bloqueausuario(){
        let codinter='300174';
        return this.httpClient.put(`${environment.baseUrl}/consultaPolizas/getMensajeria.php`,codinter);
    }

    getUsuario(){
        let variable=JSON.parse(localStorage.getItem("currentUser"));
        let codinter= variable.codinter;
        return this.httpClient.get(`${environment.baseUrl}/login/usuario.php?producto=${codinter}`);
    }

    isToken(){
        return this.httpClient.get(`${environment.baseUrl}/login/verficaToken.php`);
    }

}